import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

/**
 * Fetches active master-data values for a category. Returns a stable array of {id, value, code}.
 * Values remain visible even if inactive when passed `includeInactive: true`.
 */
export function useMasterData(category, { includeInactive = false } = {}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!category) return;
    setLoading(true);
    try {
      const { data } = await api.get("/master-data", {
        params: { category, include_inactive: includeInactive },
      });
      setItems(data);
    } finally {
      setLoading(false);
    }
  }, [category, includeInactive]);

  useEffect(() => { load(); }, [load]);

  return { items, loading, reload: load };
}

export function useJobPortals({ includeInactive = false } = {}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/job-portals", {
        params: { include_inactive: includeInactive },
      });
      setItems(data);
    } finally {
      setLoading(false);
    }
  }, [includeInactive]);

  useEffect(() => { load(); }, [load]);

  return { items, loading, reload: load };
}
